import HomeSelector from "@/modules/home/views/HomeSelector";
import ApiProductsView from "@/modules/home/views/ApiProductsView";
import HomeView from '@/modules/home/views/HomeView.vue';

export const HomeRoutes = [
    {
        path: '/',
        component: HomeSelector,
    },
    {
        path: '/api-products',
        component: ApiProductsView,
    },
    {
        path: '/home',
        component: HomeView,
    }
];
